.ui-input-search {
  display: inline-flex;
  align-items: center;
  width: 36px;
  height: 36px;
  background: transparent;
  border: 1px solid transparent;
  border-radius: var(--lemn-radius-medium);
  color: var(--lemn-color-text);
  overflow: hidden;
  vertical-align: middle;
  transition:
    width var(--lemn-duration-slow) var(--lemn-easing-emphasized),
    border-color var(--lemn-duration-normal) var(--lemn-easing-standard);
}

/* Height stays constant across states — only width and border-color animate, so
 * expanding never reflows the surrounding row. */
.ui-input-search[data-expanded="expanded"] {
  width: 280px;
  border-color: var(--lemn-color-border);
}

.ui-input-search[data-expanded="expanded"]:focus-within {
  border-color: var(--lemn-color-accent);
}

.ui-input-search__trigger {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 100%;
  padding: 0;
  background: transparent;
  border: 0;
  color: var(--lemn-color-text-muted);
  cursor: pointer;
  transition: color var(--lemn-duration-fast) var(--lemn-easing-standard);
}

.ui-input-search__trigger:hover {
  color: var(--lemn-color-text);
}

.ui-input-search[data-expanded="expanded"] .ui-input-search__trigger {
  width: auto;
  justify-content: flex-start;
  padding-left: var(--lemn-space-3);
  pointer-events: none;
  cursor: default;
}

.ui-input-search__input {
  flex: 1;
  width: 0;
  min-width: 0;
  padding: 0;
  appearance: none;
  background: transparent;
  border: 0;
  color: inherit;
  font-family: var(--lemn-font-body);
  font-size: var(--lemn-font-size-small);
  opacity: 0;
  pointer-events: none;
  outline: none;
  transition: opacity var(--lemn-duration-normal) var(--lemn-easing-standard);
}

.ui-input-search[data-expanded="expanded"] .ui-input-search__input {
  padding-left: var(--lemn-space-2);
  padding-right: var(--lemn-space-2);
  opacity: 1;
  pointer-events: auto;
}

.ui-input-search__input::-webkit-search-cancel-button,
.ui-input-search__input::-webkit-search-decoration {
  appearance: none;
  display: none;
}

.ui-input-search__clear {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin-right: var(--lemn-space-3);
  padding: 0;
  background: transparent;
  border: 0;
  border-radius: var(--lemn-radius-small);
  color: var(--lemn-color-text-muted);
  cursor: pointer;
}

.ui-input-search__clear:hover {
  background: var(--lemn-color-surface-muted);
  color: var(--lemn-color-text);
}
